/** Duvar arkası hidrostatik su itkisi (yatay). y: taban üstünden bileşke yüksekliği. */
export function hydrostatic(hw: number, gw: number): { F: number; y: number } {
  if (hw <= 0) return { F: 0, y: 0 };
  return { F: 0.5 * gw * hw * hw, y: hw / 3 };
}

/** TBDY 2018 Denk. (16.20): ΔPsu = (7/12)·khw·γw·dsu² (khw = 0,4·SDS; doğrudan katsayı modunda kh), tabandan 0,4·dsu. */
export function hydrodynamic(hw: number, gw: number, khWater: number): { F: number; y: number } {
  if (hw <= 0) return { F: 0, y: 0 };
  return { F: (7 / 12) * khWater * gw * hw * hw, y: 0.4 * hw };
}

/** Taban altı kaldırma: topukta γw·hwBack, burunda γw·hwFront, doğrusal. x: burundan bileşke mesafesi. */
export function uplift(B: number, hwBack: number, hwFront: number, gw: number): { U: number; x: number } {
  const uToe = gw * Math.max(0, hwFront), uHeel = gw * Math.max(0, hwBack);
  const U = ((uToe + uHeel) / 2) * B;
  if (U <= 0) return { U: 0, x: B / 2 };
  const x = (B * (uToe + 2 * uHeel)) / (3 * (uToe + uHeel));
  return { U, x };
}
